module.exports = __webpack_public_path__ + "img/yishi21.c0a9b5f7.jpg";